export default __webpack_public_path__ + "static/media/withdraw.9165b5b0.svg";